import { Outlet, createFileRoute } from '@tanstack/react-router';
import { evaluateAdminOnlyAccess, requireAdminAccess } from '../../../../features/admin';
import { requireMarketEnabled } from '../../../../features/market';

export const Route = createFileRoute('/_auth/admin/market')({
  beforeLoad: async (ctx) => {
    await requireMarketEnabled(ctx);
    requireAdminAccess(evaluateAdminOnlyAccess)();
  },
  component: () => <Outlet />,
});
